/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Status_Pending_ApprovalInputs */

const en_booking_status_pending_approval = /** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending Approval`)
};

const es_booking_status_pending_approval = /** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente de Aprobación`)
};

const fr_booking_status_pending_approval = /** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente d'approbation`)
};

const de_booking_status_pending_approval = /** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehende Genehmigung`)
};

const id_booking_status_pending_approval = /** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu Persetujuan`)
};

/** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */
const ja_booking_status_pending_approval = en_booking_status_pending_approval;

/** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */
const zh_booking_status_pending_approval = en_booking_status_pending_approval;

/** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */
const ar_booking_status_pending_approval = en_booking_status_pending_approval;

/** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */
const it_booking_status_pending_approval = en_booking_status_pending_approval;

/** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */
const ru_booking_status_pending_approval = en_booking_status_pending_approval;

/** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */
const pt_booking_status_pending_approval = en_booking_status_pending_approval;

/** @type {(inputs: Booking_Status_Pending_ApprovalInputs) => LocalizedString} */
const ko_booking_status_pending_approval = en_booking_status_pending_approval;

/**
* | output |
* | --- |
* | "Pending Approval" |
*
* @param {Booking_Status_Pending_ApprovalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const booking_status_pending_approval = /** @type {((inputs?: Booking_Status_Pending_ApprovalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Status_Pending_ApprovalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_booking_status_pending_approval(inputs)
	if (locale === "es") return es_booking_status_pending_approval(inputs)
	if (locale === "fr") return fr_booking_status_pending_approval(inputs)
	if (locale === "de") return de_booking_status_pending_approval(inputs)
	if (locale === "ja") return ja_booking_status_pending_approval(inputs)
	if (locale === "zh") return zh_booking_status_pending_approval(inputs)
	if (locale === "ar") return ar_booking_status_pending_approval(inputs)
	if (locale === "id") return id_booking_status_pending_approval(inputs)
	if (locale === "it") return it_booking_status_pending_approval(inputs)
	if (locale === "ru") return ru_booking_status_pending_approval(inputs)
	if (locale === "pt") return pt_booking_status_pending_approval(inputs)
	return ko_booking_status_pending_approval(inputs)
});